import React from 'react'
import Balance from './components/Balance'
import TransactionsList from './components/TransactionsList'
import AddTransaction from './components/AddTransaction'
import { GlobalProvider } from './context/globalContext'
import IncomeExpences from './components/IncomeExpences'
import './App.css'

const App = () => {
  return (
    <GlobalProvider>
      <div className="app-container">
        <h1>💵 Expense Tracker</h1>
        <Balance />
        <TransactionsList />
        <IncomeExpences />
        <AddTransaction />
      </div>
    </GlobalProvider>
  )
}

export default App
